module.exports = __webpack_public_path__ + "static/media/home_stage.72902206.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_stage.png
// module id = 394
// module chunks = 14